export const COLORS = {
  primary: "hsl(259deg, 100%, 44%)",
  secondary: "hsl(333deg, 100%, 50%)",
  statName: "dimgray",
};
